import React, { useState, useRef, useEffect } from 'react'
import SingleDropdown from '../../components/SingleDropdown.js'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { addDays, format } from 'date-fns'
import './Settings.css'
import axios from 'axios'
import ImageUpload from '../../components/ImageUpload.js'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import Toggle from '../../components/Toggle.js'
import { RiArrowUpDownFill } from 'react-icons/ri'
import { Link } from 'react-router-dom'
import { AiFillPlusCircle } from 'react-icons/ai'
import { IoMdDownload } from 'react-icons/io'
import Tooltip from '../../components/Tooltip.js'
import { MdOutlinePayment } from 'react-icons/md'
import OtpVerify from '../../components/Forms/OtpVerify.js'
import Popup from '../../components/Popup/Popup.js'
import SmallLoader from '../../components/SmallLoader.js'
import { TiTick } from 'react-icons/ti'
import { useLocation } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import constant from '../../constant/constant.js'
import countryCodeOptions from '../../data/countryCode.js'
import stateListOption from '../../data/stateList.js'
import { logout } from '../../store/authSlice.js'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTitle } from '../../hooks/useTitle.js'
import { useParams } from 'react-router-dom'
import { setUser } from "../../store/authSlice.js";
const Settings = () => {
  const user = useSelector(state => state.auth)
  useTitle('Manage Profile - Flapone Aviation')
  const { id } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const passwordRef = useRef(null);
  const location = useLocation()

  const genderOptions = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Prefer Not To Say', label: 'Prefer Not To Say' }
  ]

  const parentTitleOptions = [
    { value: 'S/o', label: 'S/o' },
    { value: 'D/o', label: 'D/o' },
    { value: 'W/o', label: 'W/o' }
  ]
  const guardianOptions = [
    { value: 'Father', label: 'Father' },
    { value: 'Mother', label: 'Mother' },
    { value: 'Sister', label: 'Sister' },
    { value: 'Brother', label: 'Brother' },
    { value: 'Other', label: 'Other' }
  ]


  const webisteOptions = [
    { value: 'https', label: 'https' },
    { value: 'http', label: 'http' }
  ]
  const [dataStatus, setDataStatus] = useState(false)
  const [settingsData, setSettingsData] = useState({
    profileImage: '',
    name: '',
    user_type: '',
    relation: {},
    relation_name: '',
    email_id: '',
    mobile_number: '',
    mblsts: '',
    emlsts: '',
    country_code: {label:"+91",value:"+91"},
    gststate: {},
    gstnumber: "",
    gender: {},
    dob: null,
    birth_place: '',
    address: '',
    landmark: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    company_name: '',
    email_status: '',
    mobile_status: '',
    profile_img_status: false,
    otp_msg: '',
    website_type: {},
    website: '',
    guardian_name: '',
    guardian_country_code: {},
    guardian_contact_number: '',
    guardianDetails: [
      {
        guardianType: {},
        guardianName: '',
        guardianMobileCode: {},
        guardianMobile: ''
      }
    ]
  })

  const [passwordOnOff, setPasswordOnOff] = useState(false)
  const [gstOnOff, setGstOnOff] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [newPassword, setNewPassword] = useState('')
  const [courseData, setCourseData] = useState([])

  const [isPhoneVerificationOpen, setIsPhoneVerificationOpen] = useState(false)
  const [loadingPhoneVerification, setLoadingPhoneVerification] =
    useState(false)
  const [sendEmailVerified, setSendEmailVerified] = useState(false)
  const [initialValue, setInitialValue] = useState(false)
  const bottomRef = useRef(null)
  const [checkRoleStatus, setCheckRoleStatus] = useState(0);
  const [checkRoleStatusField, setCheckRoleStatusField] = useState(0);
  const [errorMsgData, setErrorMsgData] = useState({})

  var errorMsg = {}

  const checkUserLogin = response => {
    if (response.data.login.status === 0) {
      dispatch(logout())
      navigate('/login')
    }
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })



  const localStorageDataUpdate = (key, value) => {
    var getlocalsession = localStorage.getItem('flaponestudentlogdetails');
    if (getlocalsession) {
        var getSavedLocalData = JSON.parse(atob(atob(getlocalsession)));
        getSavedLocalData[key] = value;
        localStorage.setItem("flaponestudentlogdetails", btoa(btoa(JSON.stringify(getSavedLocalData))));
        dispatch(setUser(getSavedLocalData));
    }
};


  const handleValidateForm = (id, value) => {
    errorMsg = errorMsgData;

    if (id === 'email_id') {
      setSettingsData({ ...settingsData, emlsts: '' })
      value = value.trim()
      if (value.length === 0) {
        errorMsg.email_id = 'Email field is empty!'
      } else {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
        if (!emailRegex.test(value)) {
          errorMsg.email_id = 'Invalid email: ' + value
        } else {
          errorMsg.email_id = ''
          handleFormSetting(id, value)
          localStorageDataUpdate('email_id',value);
        }
      }
    }

    if (id === 'mobile_number') {
      setSettingsData({ ...settingsData, mblsts: '' })
      value = value.trim()
      if (value.length === 0) {
        errorMsg.mobile_number = 'Mobile no is empty!'
      } else {
        if (settingsData.country_code['value'] !== '+91') {
          const mobileRegex = /^\d{5,20}$/i
          if (!mobileRegex.test(value)) {
            errorMsg.mobile_number = 'Invalid Mobile No: ' + value
          } else {
            errorMsg.mobile_number = ''
            handleFormSetting(id, value)
          }
        } else {
          const mobileRegex = /^[6789]\d{9}$/i
          if (!mobileRegex.test(value)) {
            errorMsg.mobile_number = 'Invalid Mobile No: ' + value
          } else {
            errorMsg.mobile_number = ''
            handleFormSetting(id, value)
          }
        }
      }
    }

    if (id === 'address') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.address = 'Address field is empty!'
      } else {
        const addressRegex = /^[0-9a-zA-Z,.-\s#\/()&]+$/
        const isValid = addressRegex.test(value)

        if (!isValid) {
          errorMsg.address =
            'Allow some char like , . # / () & in address including 0-9,a-z'
        } else {
          errorMsg.address = ''
          handleFormSetting(id, value)
        }
      }
    }

    if (id === 'landmark') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.landmark = ''
      } else {
        const addressRegex = /^[0-9a-zA-Z,.-\s#\/()&]+$/
        const isValid = addressRegex.test(value)

        if (!isValid) {
          errorMsg.landmark =
            'Allow some char like , . # / () & in address including 0-9,a-z'
        } else {
          errorMsg.landmark = ''
          handleFormSetting(id, value)
        }
      }
    }
    if (id === 'gstnumber') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.gstnumber = ''
      } else {
        const gstnumber = /^[0-9a-zA-Z]+$/
        const isValid = gstnumber.test(value)

        if (!isValid) {
          setSettingsData({ ...settingsData, gstnumber: '' })
          errorMsg.gstnumber =
            'Allow only (0-9, A-Z, a-z)'
        } else {
          errorMsg.gstnumber = ''
          handleFormSetting(id, value)
        }
      }
    }

    if (id === 'city') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.city = 'City field is empty!'
      } else {
        const cityRegex = /^[a-zA-Z\s.\-&]+$/
        const isValid = cityRegex.test(value)
        if (!isValid) {
          errorMsg.city = 'Only a-z,A-Z . - & Allowed'
        } else {
          errorMsg.city = ''
          handleFormSetting(id, value)
        }
      }
    }

    

    if (id === 'country') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.country = 'Country field is empty!'
      } else {
        const countryRegex = /^[a-zA-Z\s.\-&]+$/
        const isValid = countryRegex.test(value)
        if (!isValid) {
          errorMsg.country = 'Only a-z,A-Z . - & Allowed'
        } else {
          errorMsg.country = ''
          handleFormSetting(id, value)
        }

        let pincodeval = settingsData.pincode;
        
        if (pincodeval) {  
          if (value && value !== 'India' && value !== 'india') {
            errorMsg.pincode = ''
            handleFormSetting("pincode", pincodeval)
          }else{
          if (pincodeval.length < 4 || pincodeval.length > 12) {
            errorMsg.pincode = 'Invalid Pincode: ' + pincodeval
          } else {
            const isValid = /^[0-9]{6}$/.test(pincodeval)
            if (!isValid) {
              errorMsg.pincode = 'Pincode must be a 6-digit number.'
            } else {
              errorMsg.pincode = ''
              handleFormSetting("pincode", pincodeval)
            }
          }
        }
        }

      }
    }

    if (id === 'state') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.state = 'State field is empty!'
      } else {
        const stateRegex = /^[a-zA-Z\s.\-&]+$/
        const isValid = stateRegex.test(value)

        if (!isValid) {
          errorMsg.state = 'Only a-z,A-Z . - & Allowed'
        } else {
          errorMsg.state = ''
          handleFormSetting(id, value)
        }
      }
    }

    if (id === 'pincode') {
      value = value.trim()

      if (value.length === 0) {
        errorMsg.pincode = 'Pincode field is empty!'
      } else {
         if(settingsData.country && (settingsData.country!== 'India' && settingsData.country!== 'india')){
          errorMsg.pincode = ''
          handleFormSetting(id, value)
        }else{
        if (value.length < 4 || value.length > 12) {
          errorMsg.pincode = 'Invalid Pincode: ' + value
        } else {
          const isValid = /^[0-9]{6}$/.test(value)
          if (!isValid) {
            errorMsg.pincode = 'Pincode must be a 6-digit number.'
          } else {
            errorMsg.pincode = ''
            handleFormSetting(id, value);
          }
        }
      }
      }
    }

    if(id === 'name') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.name = 'Name field is empty!'
      } else {
          errorMsg.name = '';
          handleFormSetting(id, value)
          localStorageDataUpdate('name',value);
        }
    }

    if(id === 'company_name') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.company_name = 'Company Name field is empty!'
      } else {
          errorMsg.company_name = '';
          handleFormSetting(id, value)
        }
    }

    

    if(id === 'guardian_name') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.guardian_name = 'Guardian Name field is empty!'
      } else {
          errorMsg.guardian_name = '';
          handleFormSetting(id, value)
        }
    }
    
    
    if (id === 'guardian_contact_number') {
     
      value = value.trim()
      if (value.length === 0) {
        errorMsg.guardian_contact_number = 'Contact Person No is empty!'
      } else {
        if (settingsData.guardian_country_code['value'] !== '+91') {
          const mobileRegex = /^\d{5,20}$/i
          if (!mobileRegex.test(value)) {
            errorMsg.guardian_contact_number = 'Invalid Contact Person No: ' + value
          } else {
            errorMsg.guardian_contact_number = ''
            handleFormSetting(id, value)
          }
        } else {
          const mobileRegex = /^[6789]\d{9}$/i
          if (!mobileRegex.test(value)) {
            errorMsg.guardian_contact_number = 'Invalid Contact Person No: ' + value
          } else {
            errorMsg.guardian_contact_number = ''
            handleFormSetting(id, value)
          }
        }
      }
    }

    if(id === 'relation_name') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.relation_name = 'Parent Name field is empty!'
      } else {
          errorMsg.relation_name = '';
          handleFormSetting(id, value)
        }
    }

   
    
    if (id === 'birth_place') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.birth_place = 'Birth Place field is empty!'
      } else {
        const birthRegex = /^[a-zA-Z\s.\-&]+$/
        const isValid = birthRegex.test(value)
        if (!isValid) {
          errorMsg.birth_place = 'Only a-z,A-Z . - & Allowed'
        } else {
          errorMsg.birth_place = ''
          handleFormSetting(id, value)
        }
      }
    }

    if (id === 'website') {
      value = value.trim();
      if (value.length === 0) {
        errorMsg.website = 'Website field is empty!';
      } else {
        const mapUrlRegex = /^(www\.)?([\w\-]+\.)+([a-z]{2,})(\/[\w\-./?%&=]*)?$/i;
        const validTlds = /\.(com|in|co|org|net|info|biz)$/i; // Add any additional TLDs as needed
    
        const isValid = mapUrlRegex.test(value) && validTlds.test(value);
        
        if (!isValid) {
          errorMsg.website = "Invalid Website URL. It must end with .com, .in, .co, or other valid TLDs.";
        } else {
          errorMsg.website = '';
          handleFormSetting(id, value);
        }
      }
    }
    
    
    if(id === 'gender') {
      value = value.trim()
      if (value.length === 0) {
        errorMsg.gender = 'Please Select Gender'
      } else {
          errorMsg.gender = '';
          handleFormSetting(id, value)
        }
    }
    

    if (Object.keys(errorMsg).length > 0) {
      setErrorMsgData(errorMsg);
      return false
    }
  }

  const handleChange = e => {
    const { id, value } = e.target
    setSettingsData({ ...settingsData, [id]: value })
    const validatefields = [
      'address',
      'city',
      'state',
      'country',
      'pincode',
      'landmark',
      'gstnumber',
      'birth_place',
      'mobile_number',
      'email_id',
      'name',
      'relation_name',
      'website',
      'guardian_name',
      'guardian_contact_number',
      'company_name',
    ]

    if (validatefields.includes(id)) {
      handleValidateForm(id, value)
    } else {
      handleFormSetting(id, value)
    }
  }

  
  const guardianDetailsValidation=(id,index,value)=>{
    const updatedGuardiansMobile = [...settingsData.guardianDetails]
    updatedGuardiansMobile[index]['mobilevalidation'] = "";

    if (id === 'guardianMobile') {
      value = value.trim()
      if (value.length === 0) {
        updatedGuardiansMobile[index]['mobilevalidation'] = 'Mobile no is empty!'
        return false;
      } else {
          if (updatedGuardiansMobile[index]['guardianMobileCode']['value'] !== '+91') {
            const mobileRegex = /^\d{5,20}$/i
            if (!mobileRegex.test(value)) {
                 updatedGuardiansMobile[index]['mobilevalidation'] = 'Invalid Mobile No: ' + value
                 return false;
            } else {
              updatedGuardiansMobile[index]['mobilevalidation'] ='';
            }
          } else {
            const mobileRegex = /^[6789]\d{9}$/i
            if (!mobileRegex.test(value)) {
              updatedGuardiansMobile[index]['mobilevalidation'] = 'Invalid Mobile No: ' + value
              return false;
            } else {
              updatedGuardiansMobile[index]['mobilevalidation'] ='';
            }
          }
        }
      }
  }


  const guardianMobileCodeDetailsValidation=(id,index)=>{
    const updatedGuardiansMobile = [...settingsData.guardianDetails]
    updatedGuardiansMobile[index]['mobilevalidation'] = "";
    let value;
    
    if (id === 'guardianMobileCode') { 
     value = updatedGuardiansMobile[index]['guardianMobile'].trim();
      if (value.length === 0) {
        updatedGuardiansMobile[index]['mobilevalidation'] = 'Mobile no is empty!'
      } else {
          if (updatedGuardiansMobile[index]['guardianMobileCode']['value'] !== '+91') {
            const mobileRegex = /^\d{5,20}$/i
            if (!mobileRegex.test(value)) {
                 updatedGuardiansMobile[index]['mobilevalidation'] = 'Invalid Mobile No: ' + value
            } else {
              updatedGuardiansMobile[index]['mobilevalidation'] ='';
            }
          } else {
            const mobileRegex = /^[6789]\d{9}$/i
            if (!mobileRegex.test(value)) {
              updatedGuardiansMobile[index]['mobilevalidation'] = 'Invalid Mobile No: ' + value
              
            } else {
              updatedGuardiansMobile[index]['mobilevalidation'] ='';
            }
          }
        }
      }
  }

  const handleGuardianChange = (e, index) => {
    const { id, value } = e.target
    const updatedGuardians = [...settingsData.guardianDetails]
    updatedGuardians[index][id] = value

    if(id === 'guardianMobile'){
      guardianDetailsValidation(id,index,value,updatedGuardians);
    }

    if(id === 'guardianMobileCode'){
      guardianMobileCodeDetailsValidation(id,index,updatedGuardians);
    }

    setSettingsData({ ...settingsData, guardianDetails: updatedGuardians })
    handleFormSetting('guardianDetails', updatedGuardians)
  }

  const handleDateChange = date => {
    setSettingsData({ ...settingsData, dob: date })
    const dobdt = date ? format(new Date(date), 'yyyy-MM-dd') : ''
    handleFormSetting('dob', dobdt)
  }

  const customDateFormat = 'dd/MM/yyyy'
  const startDate = new Date(
    new Date().setFullYear(new Date().getFullYear() - 15)
  )
  const handleAddGuardian = () => {
    const newGuardian = {
      guardianType: '',
      guardianName: '',
      guardianMobileCode: '',
      guardianMobile: ''
    }
    setSettingsData({
      ...settingsData,
      guardianDetails: [...settingsData.guardianDetails, newGuardian]
    })
  }
  const passwordHandle = () => {
    if (passwordOnOff === false) {
      setPasswordOnOff(true)
    } else {
      setPasswordOnOff(false)
    }
  }
  const gstHandle = () => {
    if (gstOnOff === false) {
      setGstOnOff(true)
    } else {
      setGstOnOff(false)
    }
  }
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const closePhoneVerification = () => {
    setIsPhoneVerificationOpen(false)
  }
  const openPhoneVerification = () => {
    setIsPhoneVerificationOpen(true)
  }

  const handleChangeDropdownData = (fieldkey, label, option) => {
    const validatefields = [
      'gender',
    ]
    if (validatefields.includes(fieldkey)) {
      handleValidateForm(fieldkey, option.value)
    } else {
      handleFormSetting(fieldkey, option.value)
    }
  }


  useEffect(() => {
   
    const pathname = location.search;
    if (pathname === '?tab=Settings&section=newpass') {
      setInitialValue(true)
      setPasswordOnOff(true)
      
      window.scrollTo({
        top: document.documentElement.scrollHeight+200,
      });

      setTimeout(() => {
        passwordRef.current?.focus();
      }, 100);
      
    }
  }, [location.search])

  useEffect(() => {
    getSettingData()
  }, [])
  //=============code for api===================

  function getSettingData () {
    //setLoading(true);
    setDataStatus(false);
    axios({
      method: 'post',
      url: `${constant.base_url}/student/student_myaccount.php?fun=settingData`,
      headers: { 'Auth-Id': user.auth_id },
      data: {
        userid: id
      }
    })
      .then(function (response) {
        checkUserLogin(response)

        if (response.data.data.status === '1') {
          if (response.data.data.detail) {
            setSettingsData(response.data.data.detail)
            if(response.data.data.detail.user_type == "student"){
              if(response.data.data.detail.gstnumber){
                gstHandle();
              } else if (response.data.data.detail.company_name){
                gstHandle();
              }
            } else {
              if(response.data.data.detail.gstnumber){
                gstHandle();
              }
            }
          }

          if (response.data.data.mycourselist) {
            setCourseData(response.data.data.mycourselist)
          }
          if(response.data.data.check_role_status){
            setCheckRoleStatus(response.data.data.check_role_status);
          }
          if(response.data.data.check_role_status_field){
            setCheckRoleStatusField(response.data.data.check_role_status_field);
          }
          setDataStatus(true)
        }
      })
      .catch(function (error) {
        //console.error('Error during login:', error);
      })
      .finally(() => {
        //setLoading(false);
      })
  }

  const handleUploadProfileImg = imageFile => {
    if (imageFile) {
      const imageUrl = URL.createObjectURL(imageFile)
      setSettingsData(prevData => ({
        ...prevData,
        profileImage: imageUrl,
        profile_img_status: false
      }))
    } else {
      setSettingsData(prevData => ({
        ...prevData,
        profileImage: ''
      }))
    }

    let formData = new FormData()
    formData.append('file', imageFile)
    formData.set('userid', id)
    formData.set(
      'oldprofileImg',
      settingsData.profileImage ? JSON.stringify(settingsData.profileImage) : ''
    )
    formData.set('auth_id', user.auth_id)
    formData.set('fun', 'uploadImg')

    axios
      .post(
        `${constant.base_url}/student/student_myaccount.php?fun=uploadImg&type=profile`,
        formData,
        {
          headers: {
            'Auth-Id': user.auth_id,
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      .then(response => {
        checkUserLogin(response)
        if (response.data.login.status === 1) {
          if (response.data.data.status === "1"){
            if(response.data.data.image){
            localStorageDataUpdate('user_image',response.data.data.image);
            }
          }else{
            toast.error(response.data.data.msg)
          }
        }
      })
      .catch(error => {
        toast.error('Failed to Upload')
      })
  }
  function ucwords(str) {
  return str
    .toLowerCase() // Convert the whole string to lowercase first
    .replace(/\b\w/g, function(match) {
      return match.toUpperCase(); // Convert the first letter of each word to uppercase
    });
}
  const handleFormSetting = (key, value) => {
    axios({
      method: 'post',
      url: `${constant.base_url}/student/student_myaccount.php?fun=settingUpdate`,
      headers: { 'Auth-Id': user.auth_id },
      data: {
        userid: id,
        key: key,
        value: value
      }
    }).then(function (response) {
      checkUserLogin(response)

      const respdata = response.data;
      if (key === 'email_id') {
        if (respdata.data.emailstatus === 0) {
          setSettingsData({ ...settingsData, emlsts: respdata.data.msg })
        } else {
          errorMsg.email_id = ''
          setSettingsData({ ...settingsData, emlsts: '' })
        }
      }else if (key === 'mobile_number') {
        if (respdata.data.mobilestatus === 0) {
          setSettingsData({ ...settingsData, mblsts: respdata.data.msg })
        } else {
          errorMsg.mobile_number = ''
          setSettingsData({ ...settingsData, mblsts: '' })
        }
      }else if (key === 'address' || key === 'city' || key === 'state' || key === 'country' || key === 'pincode' || key === 'website' || key === 'guardian_contact_number' || key === 'birth_place') {
        if (respdata.data.status === 0) {
          setErrorMsgData({ ...errorMsgData, [key]: respdata.data.msg })
        } else {
          setErrorMsgData({ ...errorMsgData, [key]: '' })
        }
      }else if(key==='profile_img_status'){
        if (respdata.data.status === 0) {
            toast.warning(respdata.data.msg);
        } else {
          toast.success(respdata.data.msg);
        }
      }
      
    })
  }

  const handleEmailVerification = () => {
    axios({
      method: 'post',
      url: `${constant.base_url}/student/student_myaccount.php?fun=emailVarify`,
      headers: { 'Auth-Id': user.auth_id },
      data: {
        type: 'admin'
      }
    }).then(function (response) {
      checkUserLogin(response)

      if (response.data.data.status === '1') {
        toast.success(response.data.data.msg)
        setSendEmailVerified(true)
      } else {
        toast.success(response.data.data.msg)
        setSendEmailVerified(false)
      }
    })
  }

  const handleMobileVerification = () => {
    setLoadingPhoneVerification(true)
    setTimeout(() => {
      setLoadingPhoneVerification(false)
      openPhoneVerification()
    }, 2000)
  }

  function otpHandler () {
    setSettingsData({ ...settingsData, otp_msg: '', mobile_status: false })
    axios({
      method: 'post',
      url: `${constant.base_url}/student/student_myaccount.php?fun=OTPSEND`,
      headers: { 'Auth-Id': user.auth_id },
      data: {
        mobile_number: settingsData.mobile_number,
        country_code: settingsData.country_code
      }
    }).then(function (response) {
      checkUserLogin(response)

      if (response.data.data.status === '0') {
        setLoadingPhoneVerification(false)
        toast.error(response.data.data.msg)
      } else if (response.data.data.status === '1') {
        handleMobileVerification()
        toast.success(response.data.data.msg);
      }
    })
  }

  const varifyOTPFunHandle = otp => {
    axios({
      method: 'post',
      url: `${constant.base_url}/student/student_myaccount.php?fun=OTPAuth`,
      headers: { 'Auth-Id': user.auth_id },
      data: {
        otp: otp
      }
    }).then(function (response) {
      checkUserLogin(response)

      if (response.data.data.status === '0') {
        setSettingsData({
          ...settingsData,
          otp_msg: response.data.data.msg,
          mobile_status: false
        })
      } else if (response.data.data.status === '1') {
        setSettingsData({
          ...settingsData,
          otp_msg: response.data.data.msg,
          mobile_status: true
        })
      }
    })
  }

  const handlePassword = async e => {
    e.preventDefault()
    if (newPassword.length === 0) {
      toast.error('New Password field is empty!')
      return false
    }
    if (newPassword.length > 0) {
      const pattern = /^([A-Za-z\d\@\$\!\%\*\?]{8,})$/
      const isValid = pattern.test(newPassword)

      if (isValid) {
        toast.success('Password Updated Successfully')
      } else {
        toast.error(
          'Minimum 8 characters, alphanumeric and symbols (@ $ ! % * ?) allowed!'
        )
        return false
      }
    }
    handleFormSetting('newPassword', newPassword)
  }

  const paypendingamount = async wo_id => {
    axios({
      method: 'post',
      url: `${constant.base_url}/student/student_myaccount.php?fun=paypendingamount`,
      headers: { 'Auth-Id': user.auth_id },
      data: { wo_id: wo_id }
    })
      .then(function (response) {
        checkUserLogin(response)
        if (response.data.data.status === '1') {
          window.open(response.data.data.paymentlink)
        } else {
          toast.error(response.data.data.msg)
        }
      })
      .catch(function (error) {
        console.error('Error during login:', error)
      })
  }

  const handleDownloadReceiptFile = async filelink => {
    try {
      // Fetch the file from the provided link
      const response = await fetch(filelink)
      if (!response.ok) {
        throw new Error('Network response was not ok.')
      }

      // Convert the response to a Blob
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      // Create an anchor element and trigger the download
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = '' // Optionally specify a filename here
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)

      // Clean up the URL object
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
    }
  }

  const handleDownloadCertificate = async work_order_id => {
    axios({
      method: 'post',
      url: `${constant.base_url}/student/student_myaccount.php?fun=downloadcertificate`,
      headers: { 'Auth-Id': user.auth_id },
      data: { wo_id: work_order_id }
    })
      .then(function (response) {
        checkUserLogin(response)
        if (response.data.data.status === '1') {
          // Assuming certificate_file_name is an array
          response.data.data.certificate_file_name.forEach(file => {
            handleDownloadReceiptFile(constant.invoicepdfurl + file)
          })
        } else {
          toast.error(response.data.data.msg)
        }
      })
      .catch(function (error) {
        console.error('Error during login:', error)
      })
  }


//===============sorting course==========  
const flattenedCourseData = Object.values(courseData).flat()
const groupedCourses = flattenedCourseData.reduce((acc, course) => {
  if (!acc[course.work_order_id]) {
    acc[course.work_order_id] = []
  }
  acc[course.work_order_id].push(course)
  return acc
}, {})


const [activeColumn, setActiveColumn] = useState(null);
const [sortConfig, setSortConfig] = useState({direction: 'asc' });
// Sorting function
const sortedCourses = Object.entries(groupedCourses).sort((a, b) => {
  const [workOrderIdA, coursesA] = a;
  const [workOrderIdB, coursesB] = b;

  if (sortConfig.key) {
    if (sortConfig.direction === 'asc') {
      return workOrderIdA.localeCompare(workOrderIdB);
    } else {
      return workOrderIdB.localeCompare(workOrderIdA);
    }
  }
  // Add sorting logic for other keys if necessary
  return 0;
});

// Handle sort change
const handleSortChange = (key) => {
  setActiveColumn(key);

  let direction = 'desc';
  if (sortConfig.key === key && sortConfig.direction === 'desc') {
    direction = 'asc';
    setActiveColumn("");
  }
  setSortConfig({ key, direction });
};



const handleimageStatusChange=(value)=>{
  setSettingsData({ ...settingsData, "profile_img_status": value })
   handleFormSetting("profile_img_status",value);
}



const areAllValuesValid = (data, excludedKeys = []) => {
  const invalidKeys = []; // Array to store invalid keys

  for (const key in data) {
    if (excludedKeys.includes(key)) {
      continue; // Skip excluded keys
    }

    const value = data[key];

    // Check for arrays
    if (Array.isArray(value)) {
      if (value.length === 0 || value.some(item => !areAllValuesValid(item, excludedKeys))) {
        invalidKeys.push(key);
        break;
      }
    }
    
    // Check for objects
    else if (typeof value === 'object' && value !== null) {
      if (Object.keys(value).length === 0 || !areAllValuesValid(value, excludedKeys)) {
        invalidKeys.push(key);
        break;
      }
    }
    
    // Check for other falsy values
    else if (value === '' || value === null || value === undefined || value === false) {
      invalidKeys.push(key);
      break;
    }
  }

  // Log invalid keys
  if (invalidKeys.length > 0) {
    //console.log('Invalid keys:', invalidKeys);
  }

  return invalidKeys.length === 0; // Return true if no invalid keys
};



//=====================================Skip these keys===================================
const excludedFields = settingsData.user_type ==='student'?['mblsts', 'emlsts', 'landmark', 'otp_msg', 'flapone_email', 'gst', 'role_id', 'enroll_no', 'language','mobile_status','email_status','overview','website','company_name','mobilevalidation']:['mblsts', 'emlsts', 'landmark', 'otp_msg', 'flapone_email', 'gst', 'role_id', 'enroll_no', 'language','mobile_status','email_status','overview','mobilevalidation'];

const allValuesValid = areAllValuesValid(settingsData, excludedFields);

  return (
 
    <div className='account-details df fdc settings'>
      <div className='settings-head'>
        <h3 className='fc3 fw5 fs18 mt12 mb24'>
          Personal Details
          <div className='fs14 fc16 mt8 fw4 fc6'>
            Update your personal details to keep your profile information
            accurate and up-to-date.
          </div>

         {!allValuesValid && !checkRoleStatus &&( 
          <div className='fs14 fc16 mt8 fw4 fc6 error-message'>
           Please Complete Your Profile
          </div>
         )}
        </h3>
      </div>

      <div className='upload-image v-center mb16'>
        <p className='flx33 fc15 fw6 fs14 mb12 ls1'>Upload Photo</p>
        <div className='image-upload-component flx50'>
          {dataStatus && (
              <div
              className={`tooltip-container-bx w100 ${
                checkRoleStatusField ? "tooltip-main" : ""
              }`}
            >
            <ImageUpload
              onImageUpload={handleUploadProfileImg}
              imgData={settingsData.profileImage}
              imgstatus={settingsData.profile_img_status}
              allowedTypes = {["image/jpeg","image/png","image/gif"]}
              toast={toast}
              warnmsg="Unsupported file type. Please upload an image"
              imageStatusChange={handleimageStatusChange}
              userData={user}
              checkRoleStatus={checkRoleStatus}
              disabled={checkRoleStatusField}
            />
              {checkRoleStatusField>0 && (
              <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
            )}
            </div>
          )}
        </div>
      </div>

      <div className='v-center jcsb mb24 h-input'>
        <div className='form-group-settings name flx48 w100'>
          <p className='fc15 fw6 fs14 ls1'>
            Name<span className='fc5'>*</span>
          </p>
          <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && (settingsData.name!=null && settingsData.name!="") ? "tooltip-main" : ""
            }`}
          >
          <input
            type='text'
            id='name'
            placeholder='Enter Name'
            autoComplete='off'
            maxLength={30}
            className={`${checkRoleStatusField && (settingsData.name!=null && settingsData.name!="")
                ? "bg4 not-allowed"
                : "bg1"
            } br4 h40 mt8 fs14 w100 p16`}
            onBlur={handleChange}
            defaultValue={settingsData.name}
            disabled={checkRoleStatusField && (settingsData.name!=null && settingsData.name!="")}
          />
            {checkRoleStatusField>0 && (settingsData.name!=null && settingsData.name!="") && (
              <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
            )}
          </div> 
          {errorMsgData.name && (
            <p className='error-message'>{errorMsgData.name}</p>
          )}
        </div>
        <div className='form-group-settings parent-name flx48 w100'>
          <p className='fc15 fw6 fs14 ls1'>
            Parent Name<span className='fc5'>*</span>
          </p>
          <div className='v-center w100'>
            <div className='flx16 searching-drop'>
            <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.relation?.label!==undefined 
                ? "tooltip-main"
                : ""
            }`}>
              <SingleDropdown
                options={parentTitleOptions}
                selectedOption={settingsData.relation}
                onSelect={option =>
                  setSettingsData({
                    ...settingsData,
                    relation: option
                  })
                }
                handleClickUpdate={handleChangeDropdownData}
                fieldkey='relation'
                extraProps={true}
                isReadOnly={checkRoleStatusField && settingsData.relation?.label!==undefined}
                search
              />
                {checkRoleStatusField>0 && settingsData.relation?.label!==undefined && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
              </div>
            </div>
            <div className='flx1'>
            <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.relation_name!='' ? "tooltip-main" : ""
            }`}
            >
              <input
                type='text'
                id='relation_name'
                placeholder='Enter Parent Name'
                autoComplete='off'
                className={`${checkRoleStatusField && settingsData.relation_name!=''
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                onBlur={handleChange}
                defaultValue={settingsData.relation_name}
                disabled={checkRoleStatusField && settingsData.relation_name!=''}
              />
                {checkRoleStatusField>0 && settingsData.relation_name!='' && (
              <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
            )}
              </div>
            </div>
          </div>
          {errorMsgData.relation_name && (
                <p className='error-message'>{errorMsgData.relation_name}</p>
              )}
        </div>
      </div>
      <div className='v-center jcsb mb24 h-input'>
        <div className='form-group-settings email flx48 w100'>
          <div className='v-center jcsb'>
            <p className='fc15 fw6 fs14 ls1'>
              Email<span className='fc5'>*</span>
            </p>
            <span
              className={`  fs14 ls1 ${
                settingsData.email_status ? 'verified fc9' : 'fc3'
              }`}
              onClick={() => {
                if (!settingsData.email_status && !sendEmailVerified) {
                  handleEmailVerification()
                }
              }}
            >
              <div className='loader-container df aic'>
                {sendEmailVerified ? (
                  <p
                    className={`v-center ${
                      sendEmailVerified ? 'verification-status verified' : ''
                    }`}
                  >
                    Sent an email <TiTick className='fs14' />
                  </p>
                ) : settingsData.email_status ? (
                  <p
                    className={`v-center ${
                      settingsData.email_status
                        ? 'verification-status verified'
                        : ''
                    }`}
                  >
                    Verified <TiTick className='fs14' />
                  </p>
                ) : (
                  <p className='cp fc3 fs14'>Verify</p>
                )}
              </div>
            </span>
          </div>
         
          <div
            className={`tooltip-container-bx w100 ${
              (settingsData.email_status || checkRoleStatusField) ? "tooltip-main" : ""
            }`}
          >
          <input
            type='text'
            id='email_id'
            placeholder='Enter Email'
            autoComplete='off'
              className={`${settingsData.email_status || checkRoleStatusField
                ? "bg4 not-allowed"
                : "bg1"
            } br4 h40 mt8 fs14 w100 p16`}
            onBlur={handleChange}
            defaultValue={settingsData.email_id}
            disabled={settingsData.email_status || checkRoleStatusField}
          />
           {(settingsData.email_status || checkRoleStatusField>0) && (
              <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
            )}
           
          </div>
          {settingsData.emlsts && (
            <p className='error-message'>{settingsData.emlsts}</p>
          )}
          {errorMsgData.email_id && (
            <p className='error-message'>{errorMsgData.email_id}</p>
          )}
        </div>
        <div className='form-group-settings mobile flx48 w100'>
          <div className='v-center jcsb'>
            <p className='fc15 fw6 fs14 ls1'>
              Phone Number(with country code)
            </p>

            {settingsData.mobile_status ? (
              <span className='fs14 ls1 verified fc9'>
                <div className='loader-container df aic'>
                  <p className='v-center verification-status verified'>
                    Verified <TiTick className='fs14' />
                  </p>
                </div>
              </span>
            ) : loadingPhoneVerification ? (
              <SmallLoader />
            ) : !checkRoleStatusField && settingsData.country_code && settingsData.country_code.value === '+91' ? (
              <p className='fc3 fs14 ls1 cp' onClick={otpHandler}>
              Verify
              </p>
            ) : null}
          </div>
          <div className='v-center w100'>
            <div className='flx16'>
            <div
            className={`tooltip-container-bx w100 ${
              (settingsData.mobile_status || checkRoleStatusField) ? "tooltip-main" : ""
            }`}
          >
              <SingleDropdown
                options={countryCodeOptions}
                selectedOption={settingsData.country_code}
                onSelect={option =>
                  setSettingsData({
                    ...settingsData,
                    country_code: option
                  })
                }
                handleClickUpdate={handleChangeDropdownData}
                fieldkey='country_code'
                extraProps={true}
                isReadOnly={settingsData.mobile_status || checkRoleStatusField}
              />
               {(settingsData.mobile_status || checkRoleStatusField>0) && (
              <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
            )}
              </div>
            </div>
            <div className='flx1'>
            <div
            className={`tooltip-container-bx w100 ${
              (checkRoleStatusField || settingsData.mobile_status) ? "tooltip-main" : ""
            }`}
          >
              <input
                type='text'
                id='mobile_number'
                placeholder='Enter Mobile'
                autoComplete='off'
                className={`${checkRoleStatusField || settingsData.mobile_status
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                onBlur={handleChange}
                defaultValue={settingsData.mobile_number}
                disabled={settingsData.mobile_status || checkRoleStatusField}
              />
                 {(settingsData.mobile_status || checkRoleStatusField>0) && (
              <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
            )}
              </div>
            </div>
          </div>
          {settingsData.mblsts && (
            <p className='error-message'>{settingsData.mblsts}</p>
          )}
          {errorMsgData.mobile_number && (
            <p className='error-message'>{errorMsgData.mobile_number}</p>
          )}
        </div>
      </div>
      <div className='v-center jcsb mb24 h-input'>
        <div className='form-group-settings gender flx48 w100'>
        <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.gender.label!==undefined
                ? "tooltip-main"
                : ""
            }`}
          >
          <SingleDropdown
            label='Gender'
            options={genderOptions}
            selectedOption={settingsData.gender}
            onSelect={option =>
              setSettingsData({
                ...settingsData,
                gender: option
              })
            }
            handleClickUpdate={handleChangeDropdownData}
            fieldkey='gender'
            extraProps={true}
            isReadOnly={checkRoleStatusField && settingsData.gender.label!==undefined}
            required
          />
          {checkRoleStatusField>0 && settingsData.gender.label!==undefined && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
          </div>
          {errorMsgData.gender && (
            <p className='error-message'>{errorMsgData.gender}</p>
          )}
        </div>
        <div className='form-group-settings dob flx48 w100'>
          <label htmlFor='dob' className='df fs14 ls1 fw6'>
            Date of birth<span className='fc5'>*</span>
          </label>
          <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.dob!=""
                ? "tooltip-main"
                : ""
            }`}
          >
          <DatePicker
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat={customDateFormat}
            selected={settingsData.dob}
            onChange={handleDateChange}
            placeholderText='-- Select DOB --'
            isClearable={settingsData.dob}
            startDate={startDate}
            openToDate={startDate}
            disabled={checkRoleStatusField && settingsData.dob!=""}
          />
            {checkRoleStatusField>0 && settingsData.dob!="" && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
          </div>
        </div>
      </div>
      <div className='v-center jcsb mb24 h-input'>
        <div className='form-group-settings birth-place flx48 w100'>
          <p className='fc15 fw6 fs14 ls1'>
            Birth Place
          </p>
          <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.birth_place
                ? "tooltip-main"
                : ""
            }`}
          >
          <input
            type='text'
            id='birth_place'
            placeholder='Enter Birth Place'
            autoComplete='off'
            className={`${checkRoleStatusField && settingsData.birth_place!=''
              ? "bg4 not-allowed"
              : "bg1"
          } br4 h40 mt8 fs14 w100 p16`}
            onBlur={handleChange}
            defaultValue={settingsData.birth_place}
            disabled={checkRoleStatusField && settingsData.birth_place!=''}
          />
            {checkRoleStatusField>0 && settingsData.birth_place!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
          </div>
          {errorMsgData.birth_place && (
            <p className='error-message'>{errorMsgData.birth_place}</p>
          )}
        </div>
      </div>

      {settingsData.user_type !== 'student' && (
        <div className='address-section brd-t2 mt24 pt24'>
          <div className='address-head mb24'>
            <p className='fs18 fc3 ls1 lh22'>Company Information</p>
            <p className='fs14 fc6 ls1 lh18 mt4'>
              Please provide the following information about your company
            </p>
          </div>
          <div className='v-center jcsb mb24 h-input'>
            <div className='form-group-settings address flx48 w100'>
              <p className='fc15 fw6 fs14 ls1'>
                Company Name<span className='fc5'>*</span>
              </p>
               <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.company_name!=''
                ? "tooltip-main"
                : ""
            }`}
          >
              <input
                type='text'
                id='company_name'
                placeholder='Enter Address'
                autoComplete='off'
                className={`${checkRoleStatusField && settingsData.company_name!=''
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                onBlur={handleChange}
                defaultValue={settingsData.company_name}
                disabled={checkRoleStatusField && settingsData.company_name!=''}
              />
               {checkRoleStatusField>0 && settingsData.company_name!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
              </div>
              {errorMsgData.company_name && (
            <p className='error-message'>{errorMsgData.company_name}</p>
          )}
            </div>
            <div className='form-group-settings mobile flx48 w100'>
              <div className='v-center jcsb'>
                <p className='fc15 fw6 fs14 ls1'>
                  Website<span className='fc5'>*</span>
                </p>
              </div>
              <div className='v-center w100'>
                <div className='flx16'>
                <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.website_type.label!==undefined
                ? "tooltip-main"
                : ""
            }`}
          >
                  <SingleDropdown
                    options={webisteOptions}
                    selectedOption={settingsData.website_type}
                    onSelect={option =>
                      setSettingsData({
                        ...settingsData,
                        website_type: option
                      })
                    }
                    handleClickUpdate={handleChangeDropdownData}
                    fieldkey='website_type'
                    extraProps={true}
                    isReadOnly={checkRoleStatusField && settingsData.website_type!=''}
                  />
                    {checkRoleStatusField>0 && settingsData.website_type!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
                    )}
                  </div>
                </div>
                <div className='flx1'>
                    <div
                className={`tooltip-container-bx w100 ${
                  checkRoleStatusField && settingsData.website!==null
                    ? "tooltip-main"
                    : ""
                }`}>
                  <input
                    type='text'
                    id='website'
                    placeholder='Enter website'
                    autoComplete='off'
                    className={`${checkRoleStatusField && settingsData.website!=''
                      ? "bg4 not-allowed"
                      : "bg1"
                  } br4 h40 mt8 fs14 w100 p16`}
                    disabled={checkRoleStatusField && settingsData.website!=''}
                    onBlur={handleChange}
                    defaultValue={settingsData.website}
                  />
                    {checkRoleStatusField>0 && settingsData.website!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
                  </div>
                </div>
              </div>
              {errorMsgData.website && (
            <p className='error-message'>{errorMsgData.website}</p>
          )}
            </div>
          </div>

          <div className='v-center jcsb mb24 h-input'>
            <div className='form-group-settings address flx48 w100'>
              <p className='fc15 fw6 fs14 ls1'>
                Contact Person Name<span className='fc5'>*</span>
              </p>
              <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.guardian_name!=''
                ? "tooltip-main"
                : ""
            }`}
          >
              <input
                type='text'
                id='guardian_name'
                placeholder='Enter Name'
                autoComplete='off'
                className={`${checkRoleStatusField && settingsData.guardian_name!=''
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                disabled={checkRoleStatusField && settingsData.guardian_name!=''}
                onBlur={handleChange}
                defaultValue={settingsData.guardian_name}
              />
                 {checkRoleStatusField>0 && settingsData.guardian_name!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
              </div>
              {errorMsgData.guardian_name && (
            <p className='error-message'>{errorMsgData.guardian_name}</p>
          )}
            </div>
            <div className='form-group-settings mobile flx48 w100'>
              <div className='v-center jcsb'>
                <p className='fc15 fw6 fs14 ls1'>
                  Contact Person Number<span className='fc5'>*</span>
                </p>
              </div>
              <div className='v-center w100'>
                <div className='flx16'>
                <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField
                ? "tooltip-main"
                : ""
            }`}
          >
                  <SingleDropdown
                    options={countryCodeOptions}
                    selectedOption={settingsData.guardian_country_code}
                    onSelect={option =>
                      setSettingsData({
                        ...settingsData,
                        guardian_country_code: option
                      })
                    }
                    handleClickUpdate={handleChangeDropdownData}
                    fieldkey='guardian_country_code'
                    extraProps={true}
                    isReadOnly={checkRoleStatusField}
                  />
                    {checkRoleStatusField>0 && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
                  </div>
                </div>
                <div className='flx1'>
                <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.guardian_contact_number!=''
                ? "tooltip-main"
                : ""
            }`}
          >
                  <input
                    type='text'
                    id='guardian_contact_number'
                    placeholder='Enter Mobile'
                    autoComplete='off'
                    className={`${checkRoleStatusField && settingsData.guardian_contact_number!=''
                      ? "bg4 not-allowed"
                      : "bg1"
                  } br4 h40 mt8 fs14 w100 p16`}
                    disabled={checkRoleStatusField && settingsData.guardian_contact_number!=''}
                    onBlur={handleChange}
                    defaultValue={settingsData.guardian_contact_number}
                  />
                      {checkRoleStatusField>0 && settingsData.guardian_contact_number!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
                  </div>
                </div>
              </div>
              {errorMsgData.guardian_contact_number && (
            <p className='error-message'>{errorMsgData.guardian_contact_number}</p>
          )}
            </div>
          </div>
        </div>
      )}

      <div className='address-section brd-t2 mt24 pt24'>
        <div className='address-head mb24'>
          <p className='fs18 fc3 ls1 lh22'>Address Information</p>
          <p className='fs14 fc6 ls1 lh18 mt4'>
            Please enter your address details accurately to ensure we have
            accurate information for communication and verification purposes.
          </p>
        </div>
        <div className='v-center jcsb mb24 h-input'>
          <div className='form-group-settings address flx48 w100'>
            <p className='fc15 fw6 fs14 ls1'>
              Address<span className='fc5'>*</span>
            </p>
            <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.address!=''  && settingsData.address!=null 
                ? "tooltip-main"
                : ""
            }`}
          >
            <input
              type='text'
              id='address'
              placeholder='Enter Address'
              autoComplete='off'
              className={`${checkRoleStatusField && settingsData.address!='' && settingsData.address!=null 
                ? "bg4 not-allowed"
                : "bg1"
            } br4 h40 mt8 fs14 w100 p16`}
              disabled={checkRoleStatusField && settingsData.address!=''  && settingsData.address!=null }
              onBlur={handleChange}
              defaultValue={settingsData.address}
            />
             {checkRoleStatusField>0 && settingsData.address!=''  && settingsData.address!=null   && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
            </div>
            {errorMsgData.address && (
              <p className='error-message'>{errorMsgData.address}</p>
            )}
          </div>

          <div className='form-group-settings landmark flx48 w100'>
            <p className='fc15 fw6 fs14 ls1'>
              Landmark
            </p>
            <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.landmark!=''
                ? "tooltip-main"
                : ""
            }`}
          >
            <input
              type='text'
              id='landmark'
              placeholder='Enter Landmark'
              autoComplete='off'
              className={`${checkRoleStatusField && settingsData.landmark!=''
                ? "bg4 not-allowed"
                : "bg1"
            } br4 h40 mt8 fs14 w100 p16`}
              disabled={checkRoleStatusField && settingsData.landmark!=''}
              onBlur={handleChange}
              defaultValue={settingsData.landmark}
            />
               {checkRoleStatusField>0 && settingsData.landmark!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
            </div>
            {errorMsgData.landmark && (
              <p className='error-message'>{errorMsgData.landmark}</p>
            )}
          </div>
        </div>
        <div className='v-center jcsb pb32 h-input'>
          <div className='form-group-settings address flx48 v-center jcsb w100 '>
            <div className='form-group-settings city flx48 w100'>
              <p className='fc15 fw6 fs14 ls1'>
                City<span className='fc5'>*</span>
              </p>
              <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.city!='' && settingsData.city!=null
                ? "tooltip-main"
                : ""
            }`}
          >
              <input
                type='text'
                id='city'
                placeholder='Enter City'
                autoComplete='off'
                className={`${checkRoleStatusField && settingsData.city!='' && settingsData.city!=null
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                disabled={checkRoleStatusField && settingsData.city!='' && settingsData.city!=null}
                onBlur={handleChange}
                defaultValue={settingsData.city}
              />
              {checkRoleStatusField>0 && settingsData.city!='' && settingsData.city!=null && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
              </div>
              {errorMsgData.city && (
                <p className='error-message'>{errorMsgData.city}</p>
              )}
            </div>
            <div className='form-group-settings state flx48 w100'>
              <p className='fc15 fw6 fs14 ls1'>
                State<span className='fc5'>*</span>
              </p>
              {settingsData.country==="" &&

<div
className={`tooltip-container-bx w100 ${
  checkRoleStatusField && settingsData.state!=''
    ? "tooltip-main"
    : ""
}`}
>
               <input
                type='text'
                id='state'
                placeholder='Enter State'
                autoComplete='off'
                className={`${checkRoleStatusField && settingsData.state!=''
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                disabled={checkRoleStatusField && settingsData.state!=''}
                onBlur={handleChange}
                defaultValue={settingsData.state}
              />
                 {checkRoleStatusField>0 && settingsData.state!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
              </div>
              }
              {(settingsData.country && settingsData.country.toLowerCase()!=='india') &&

<div
className={`tooltip-container-bx w100 ${
  checkRoleStatusField && settingsData.state!=''
    ? "tooltip-main"
    : ""
}`}
>
               <input
                type='text'
                id='state'
                placeholder='Enter State'
                autoComplete='off'
                className={`${checkRoleStatusField && settingsData.state!=''
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                disabled={checkRoleStatusField && settingsData.state!=''}
                onBlur={handleChange}
                defaultValue={settingsData.state}
              />
                 {checkRoleStatusField>0 && settingsData.state!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
              </div>
              }
               {settingsData.country && settingsData.country.toLowerCase()==='india' && 
               <div
               className={`tooltip-container-bx w100 ${
                checkRoleStatusField && settingsData.state!=''
                   ? "tooltip-main"
                   : ""
               }`}
             > 
               <SingleDropdown
                    label=''
                    options={stateListOption}
                    selectedOption={{
                      label: ucwords(settingsData.state),
                      value: settingsData.state
                    }}
                    onSelect={option =>
                      setSettingsData({
                        ...settingsData,
                        state: option.value
                      })
                    }
                    handleClickUpdate={handleChangeDropdownData}
                    fieldkey='state'
                    extraProps={true}
                    isReadOnly={checkRoleStatusField && settingsData.state!=''}
                    search
                  />
              {checkRoleStatusField>0 && settingsData.state!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
                  </div>
                  }
              {errorMsgData.state && (
                <p className='error-message'>{errorMsgData.state}</p>
              )}
            </div>
          </div>
          <div className='form-group-settings address flx48 v-center jcsb w100'>
            <div className='form-group-settings country flx48 w100'>
              <p className='fc15 fw6 fs14 ls1'>
                Country<span className='fc5'>*</span>
              </p>
              <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.country!=''
                ? "tooltip-main"
                : ""
            }`}
          >
              <input
                type='text'
                id='country'
                placeholder='Enter Country'
                autoComplete='off'
                className={`${checkRoleStatusField && settingsData.country!=''
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                disabled={checkRoleStatusField && settingsData.country!=''}
                onBlur={handleChange}
                defaultValue={settingsData.country}
              />
              {checkRoleStatusField>0 && settingsData.country!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
              </div>
              {errorMsgData.country && (
                <p className='error-message'>{errorMsgData.country}</p>
              )}
            </div>
            <div className='form-group-settings pincode flx48 w100'>
              <p className='fc15 fw6 fs14 ls1'>
                Pincode<span className='fc5'>*</span>
              </p>
              <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && settingsData.pincode!="" && !errorMsgData.pincode
                ? "tooltip-main"
                : ""
            }`}
          >
              <input
                type='number'
                id='pincode'
                placeholder='Enter Pincode'
                autoComplete='off'
                className={`${checkRoleStatusField && settingsData.pincode!="" && !errorMsgData.pincode
                  ? "bg4 not-allowed"
                  : "bg1"
              } br4 h40 mt8 fs14 w100 p16`}
                disabled={checkRoleStatusField && settingsData.pincode!="" && !errorMsgData.pincode}
                onBlur={handleChange}
                defaultValue={settingsData.pincode }
              />
                  {checkRoleStatusField>0 && settingsData.pincode!="" && !errorMsgData.pincode && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
              </div>
              {errorMsgData.pincode && (
                <p className='error-message'>{errorMsgData.pincode}</p>
              )}
            </div>
          </div>
        </div>

        <div className='brd-t2 pt24 pb24 guardian-head'>
          <p className='fs18 fc3 ls1 lh22'>Emergency / Guardian's Contact</p>
          <p className='fs14 fc6 ls1 lh18 mt4'>
            Provide your parent or guardian's phone number to ensure we have a
            contact for any necessary updates or emergencies.
          </p>
        </div>
        {settingsData.guardianDetails &&
          settingsData.guardianDetails.map((guardian, index) => (
            <div
              key={index}
              className='v-center jcsb  guardian-details mb24 h-input'
            >
              <div className='form-group-settings parent-name flx48 w100'>
                <p className='fc15 fw6 fs14 ls1'>
                  
                  Guardian
                </p>
                <div className='v-center'>
                  <div className='flx16'>
                  <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && guardian.guardianType.label!==undefined
                ? "tooltip-main"
                : ""
            }`}
          >
                    <SingleDropdown
                      options={guardianOptions}
                      selectedOption={guardian.guardianType}
                      onSelect={option =>
                        handleGuardianChange(
                          { target: { id: 'guardianType', value: option } },
                          index
                        )
                      }
                      isReadOnly={checkRoleStatusField && guardian.guardianType.label!==undefined}
                    />
                      {checkRoleStatusField>0 && guardian.guardianType.label!==undefined && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
                    </div>
                  </div>
                  <div className='flx1'>
                  <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && guardian.guardianName!=''
                ? "tooltip-main"
                : ""
            }`}
          >
                    <input
                      type='text'
                      id='guardianName'
                      placeholder='Enter Guardian Name'
                      autoComplete='off'
                      className={`${checkRoleStatusField && guardian.guardianName!=''
                        ? "bg4 not-allowed"
                        : "bg1"
                    } br4 h40 mt8 fs14 w100 p16`}
                      disabled={checkRoleStatusField && guardian.guardianName!=''}
                      onBlur={e => handleGuardianChange(e, index)}
                      defaultValue={guardian.guardianName}
                    />
                    {checkRoleStatusField>0 && guardian.guardianName!='' && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
                   </div>
                    
                  </div>
                </div>
              </div>
              <div className='form-group-settings parent-name flx48 w100'>
                <p className='fc15 fw6 fs14 ls1'>
                  Phone Number (with country code)
                </p>
                <div className='v-center'>
                  <div className='flx16'>
                  <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && guardian.guardianMobileCode.label!==undefined
                ? "tooltip-main"
                : ""
            }`}
          >
                    <SingleDropdown
                      options={countryCodeOptions}
                      selectedOption={guardian.guardianMobileCode}
                      onSelect={option =>
                        handleGuardianChange(
                          {
                            target: { id: 'guardianMobileCode', value: option }
                          },
                          index
                        )
                      }
                      isReadOnly={checkRoleStatusField && guardian.guardianMobileCode.label!==undefined}


                    />
                    {checkRoleStatusField>0 && guardian.guardianMobileCode.label!==undefined && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
                    </div>
                  </div>
                  <div className='flx1'>
                  <div
            className={`tooltip-container-bx w100 ${
              checkRoleStatusField && guardian.guardianMobile!='' && !guardian.mobilevalidation 
                ? "tooltip-main"
                : ""
            }`}
          >
                    <input
                      type='number'
                      id='guardianMobile'
                      placeholder='Enter Guardian Number'
                      autoComplete='off'
                      className={`${checkRoleStatusField && guardian.guardianMobile!='' && !guardian.mobilevalidation 
                        ? "bg4 not-allowed"
                        : "bg1"
                    } br4 h40 mt8 fs14 w100 p16`}
                      disabled={checkRoleStatusField && guardian.guardianMobile!='' && !guardian.mobilevalidation }
                      onBlur={e => handleGuardianChange(e, index)}
                      defaultValue={guardian.guardianMobile }
                    />
                       {checkRoleStatusField>0 && guardian.guardianMobile!='' && !guardian.mobilevalidation && (
                <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
              )}
                    </div>
                  </div>
                </div>
                {guardian && guardian.mobilevalidation && (
                 <p className='error-message'>{guardian.mobilevalidation}</p>
                )}
              </div>
            </div>
          ))}
      </div>
      {!checkRoleStatusField && <div className='df jce mb24'>
        <button
          className=' pl16 pr16 pt12 pb12 bg3 fc1 br24 ls2 cp v-center fs16'
          onClick={handleAddGuardian}
        >
          Add More
          <AiFillPlusCircle className='ml8 fs20' />
        </button>
      </div>}

      <div
        className='joinde-course-list brd-t2 mt24 pt24 pb24'
        style={{ overflow: 'auto' }}
      >
        <p className='fs18 fc3 ls1 lh22'>Course Details</p>
        <p className='fs14 fc6 ls1 lh18 mt4'>
          View details of your completed and running courses here.
        </p>

        {courseData && courseData.length === 0 ? (
          <p className='fs16 fc6 ls1 lh18 box-center mt36 mb12'>
            No record found. Enroll in our course today!
            <Link
              to='https://www.flapone.com/courses'
              target='_blank'
              className='ml4 mr4 enroll'
            >
              Click here
            </Link>
            for more details
          </p>
        ) : (
          <div>
            <table className='w100 mt16 common-table wsnw'>
              <thead>
                <tr>
                  <th onClick={() => handleSortChange('work_order_id')} className={`cp icon-class ${sortConfig.key === 'work_order_id' ? sortConfig.direction : ''}`}>
                   <p className={`${activeColumn && activeColumn === 'work_order_id'?"fc3" : "fc2"} box-center`}>
                      ID
                     <RiArrowUpDownFill/>
                    </p>
                  </th>
                <th onClick={() => handleSortChange('course_name')} className={`cp icon-class ${sortConfig.key === 'course_name' ? sortConfig.direction : ''}`}>
                  <p className={`${activeColumn && activeColumn === 'course_name'?"fc3" : "fc2"} box-center`}>
                  Course Name
                     <RiArrowUpDownFill />
                    </p>
                </th>
                {/* <th onClick={() => handleSortChange('category_name')} className={`cp icon-class ${sortConfig.key === 'category_name' ? sortConfig.direction : ''}`}>
                <p className={`${activeColumn && activeColumn === 'category_name'?"fc3" : "fc2"} box-center`}>
                  Category Name
                     <RiArrowUpDownFill/>
                    </p>
                </th> */}
                {/*<th onClick={() => handleSortChange('rollNumber')} className={`cp icon-class ${sortConfig.key === 'rollNumber' ? sortConfig.direction : ''}`}>
                <p className={`${activeColumn && activeColumn === 'rollNumber'?"fc3" : "fc2"} box-center`}>
                Roll Number
                     <RiArrowUpDownFill/>
                    </p>
                </th>*/}
                <th onClick={() => handleSortChange('batch')} className={`cp icon-class ${sortConfig.key === 'batch' ? sortConfig.direction : ''}`} >
                <p className={`${activeColumn && activeColumn === 'batch'?"fc3" : "fc2"} box-center`}>
                Theory Batch
                     <RiArrowUpDownFill />
                    </p>
                </th>
                <th onClick={() => handleSortChange('fly_batch')} className={`cp icon-class ${sortConfig.key === 'fly_batch' ? sortConfig.direction : ''}`} >
                <p className={`${activeColumn && activeColumn === 'fly_batch'?"fc3" : "fc2"} box-center`}>
                Flying Batch
                     <RiArrowUpDownFill />
                    </p>
                </th>
                <th onClick={() => handleSortChange('start_date')} className={`cp icon-class ${sortConfig.key === 'start_date' ? sortConfig.direction : ''}`}>
                <p className={`${activeColumn && activeColumn === 'start_date'?"fc3" : "fc2"} box-center`}>
                Start Date
                     <RiArrowUpDownFill/>
                    </p>
                </th>
                <th onClick={() => handleSortChange('end_date')} className={`cp icon-class ${sortConfig.key === 'end_date' ? sortConfig.direction : ''}`}>
                <p className={`${activeColumn && activeColumn === 'end_date'?"fc3" : "fc2"} box-center`}>
                End Date
                     <RiArrowUpDownFill/>
                    </p>
                </th>
                <th  onClick={() => handleSortChange('status')} className={`cp icon-class ${sortConfig.key === 'status' ? sortConfig.direction : ''}`}>
                <p className={`${activeColumn && activeColumn === 'status'?"fc3" : "fc2"} box-center`}>
                      Status
                     <RiArrowUpDownFill  />
                    </p>
                </th>
                <th>
                  <p className="box-center">Pending Amt</p>
                </th>
                <th>
                  <p className="box-center">Action</p>
                </th>
              </tr>
              </thead>
              <tbody>
              {sortedCourses.map(([workOrderId, courses]) => {
                    const rowspan = courses.length;
                    return courses.map((course, index) => (
                      <tr key={`${course.work_order_id}-${index}`}>
                        {index === 0 && (
                          <td rowSpan={rowspan}>{course.work_order_id}</td>
                        )}
                        <td className='leads-tool-fix'>
                          <Tooltip title={course.course_name}>
                            {course.course_name.slice(0, 40)}
                          </Tooltip>
                        </td>
                        {/* <td>{course.category_name}</td> */}
                        {/* <td>{course.rollNumber || '--'}</td> */}
                        <td>{course.batch || '--'}</td>
                        <td>{course.fly_batch || '--'}</td>
                        <td>{course.start_date || '--'}</td>
                        <td>{course.end_date || '--'}</td>
                        <td>
                          <span>
                            {course.status}
                          </span>
                        </td>
                        {index === 0 && (
                          <>
                            <td className='fc6 ls1' rowSpan={rowspan}>
                              {course.status === 'Running' &&
                              parseFloat(course.pending_amount) > 0 ? (
                                <span className='blink-text fc5'>
                                  {formatter.format(course.pending_amount)}
                                </span>
                              ) : course.status === 'Dropped' &&
                                parseFloat(course.pending_amount) > 0 ? (
                                <span className='blink-text fc5'>
                                  {' '}
                                  {formatter.format(course.pending_amount)}{' '}
                                </span>
                              ) : course.status === 'Pending' &&
                                parseFloat(course.pending_amount) > 0 ? (
                                <span className='blink-text fc5'>
                                  {' '}
                                  {formatter.format(course.pending_amount)}{' '}
                                </span>
                              ) : course.status === 'Completed' &&
                                parseFloat(course.pending_amount) > 0 ? (
                                <span className='blink-text fc5'>
                                  {' '}
                                  {formatter.format(course.pending_amount)}{' '}
                                </span>
                              ) : (
                                formatter.format(course.pending_amount)
                              )}
                            </td>
                          </>
                        )}

                        {index === 0 && (
                          <td
                             className='leads-tool-fix'
                            rowSpan={
                              parseFloat(course.pending_amount) < 1
                                ? ''
                                : rowspan
                            }
                          >
                            {course.status === 'Completed' && 
                            parseFloat(course.pending_amount) > 0 ? (
                               <span
                                className='ml4 bg-outline-info badge badge-status cp'
                                onClick={() =>
                                  paypendingamount(course.work_order_id)
                                  }
                              >
                                <MdOutlinePayment className='mr4' /> Pay Now
                              </span>
                            ) : course.status === 'Running' && 
                              parseFloat(course.pending_amount) > 0 ? (
                              <span
                                className='ml4 bg-outline-info badge badge-status cp '
                                onClick={() =>
                                  paypendingamount(course.work_order_id)
                                }
                              >
                                <MdOutlinePayment className='mr4' /> Pay Now
                              </span>
                            ) : course.status === 'Dropped' ? (
                              '--'
                            ) : course.status === 'Pending' &&  
                              parseFloat(course.pending_amount) > 0 ? (
                              <span
                                className='ml4 bg-outline-info badge badge-status cp '
                                onClick={() =>
                                  paypendingamount(course.work_order_id)
                                }
                              >
                                <MdOutlinePayment className='mr4' /> Pay Now
                              </span>
                            ) /*: course.status === 'Completed' && 
                              parseFloat(course.pending_amount) < 1 ? (
                              <Tooltip title='Download Certificate'>
                                <IoMdDownload
                                  className='fc6 fs24 cp'
                                  onClick={() =>
                                    handleDownloadCertificate(
                                      course.work_order_id
                                    )
                                  }
                                />
                              </Tooltip>
                            )*/ : (
                              '--'
                            )}
                          </td>
                        )}

                        {course.status === 'Completed' &&
                          parseFloat(course.pending_amount) < 1 &&
                          index !== 0 && (
                            <td className='leads-tool-fix'>
                              <Tooltip title='Download Certificate'>
                                <IoMdDownload
                                  className='fc6 fs24 cp'
                                  onClick={() =>
                                    handleDownloadCertificate(
                                      course.work_order_id
                                    )
                                  }
                                />
                              </Tooltip>
                            </td>
                          )}

                          {course.status === 'Pending' &&
                          parseFloat(course.pending_amount) < 1 &&
                          index !== 0 && (
                            <td >
                              --
                            </td>
                          )}

                          {course.status === 'Running' &&
                          parseFloat(course.pending_amount) < 1 &&
                          index !== 0 && (
                            <td >
                              --
                            </td>
                          )}

                          {course.status === 'Dropped' &&
                          parseFloat(course.pending_amount) < 1 &&
                          index !== 0 && (
                            <td >
                              --
                            </td>
                          )}
                      </tr>
                    ))
                  }
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {/*user.user_type === "company" && (
        <div className='reset-password brd-t2'>
          <div className='reset-pass-head mt24'>
            <div className='v-center'>
              <p className=' fc3 fs18 ls1 lh22 mr8'>GST Details</p>
              {(!settingsData.gstnumber) &&<Toggle  onChange={gstHandle} />}
            </div>
            <p className='ls1 fc6 fs14 mt4 mb24 lh22'>
            Your GST details is crucial for accurate invoicing and tax compliance, please fill out your GST details below:
            </p>
          </div>
          {(gstOnOff || settingsData.gstnumber)  && (
            <>
            <div className='v-center jcsb mb24 h-input'>
              <div className='form-group-settings landmark w100'>
                <p className='fc15 fw6 fs14 ls1'>
                  GST Number
                </p>
                <div
                className={`tooltip-container-bx w100 ${
                  checkRoleStatusField && settingsData.gstnumber!=''
                    ? "tooltip-main"
                    : ""
                }`}
              >
                <input
                  type='text'
                  id='gstnumber'
                  placeholder='Enter GST Number'
                  autoComplete='off'
                  className={`${checkRoleStatusField && settingsData.gstnumber!=''
                    ? "bg4 not-allowed"
                    : "bg1"
                } br4 h40 mt8 fs14 w100 p16`}
                  disabled={checkRoleStatusField && settingsData.gstnumber!=''}
                  onBlur={handleChange}
                  defaultValue={settingsData.gstnumber}
                />
                {checkRoleStatusField>0 && settingsData.gstnumber!='' && (
                  <span className="tooltip-texts">This field is not editable. Please contact support or your coordinator for any necessary changes</span>
                )}
                </div>
                {errorMsgData.gstnumber && (
                  <p className='error-message'>{errorMsgData.gstnumber}</p>
                )}
              </div>
            </div>
            </>
          )}
        </div>
      )*/}
      <div className='reset-password brd-t2'>
        <div className='reset-pass-head mt24'>
          <div className='v-center'>
            <p className=' fc3 fs18 ls1 lh22 mr8'>Required GST Bill</p>
            <Toggle
              onChange={gstHandle}
              initialValue={gstOnOff}
            />
          </div>
          <p className='ls1 fc6 fs14 mt4 mb24 lh22'>
            Please provide your GST details to ensure accurate invoicing and tax compliance. Any updates will be reflected in future invoices.
          </p>
        </div>
        {(gstOnOff ) && (
          <div className='v-center jcsb mb24 h-input'>
            {user.user_type !== "company" && (
              <div className='form-group-settings landmark flx48'>
                <p className='fc15 fw6 fs14 ls1'>Company Name</p>
                <div
                  className={`tooltip-container-bx w100 ${
                    checkRoleStatusField && settingsData.company_name !== ''
                      ? "tooltip-main"
                      : ""
                  }`}
                >
                  <input
                    type='text'
                    id='company_name'
                    placeholder='Enter GST Company'
                    autoComplete='off'
                    className={`${
                      checkRoleStatusField && settingsData.company_name !== ''
                        ? "bg4 not-allowed"
                        : "bg1"
                    } br4 h40 mt8 fs14 w100 p16`}
                    disabled={checkRoleStatusField && settingsData.company_name !== ''}
                    onBlur={handleChange}
                    defaultValue={settingsData.company_name}
                  />
                  {checkRoleStatusField > 0 && settingsData.company_name !== '' && (
                    <span className="tooltip-texts">
                      This field is not editable. Please contact support or your coordinator for any necessary changes
                    </span>
                  )}
                </div>
                {errorMsgData.company_name && user.user_type !== "student" && (
                  <p className='error-message'>{errorMsgData.company_name}</p>
                )}
              </div>
            )}

            <div className={`form-group-settings landmark ${user.user_type !== 'company' ? " flx48" : "flx100"}`}>
              <p className='fc15 fw6 fs14 ls1'>GST Number</p>
              <div
                className={`tooltip-container-bx w100 ${
                  checkRoleStatusField && settingsData.gstnumber !== ''
                    ? "tooltip-main"
                    : ""
                }`}
              >
                <input
                  type='text'
                  id='gstnumber'
                  placeholder='Enter GST Number'
                  autoComplete='off'
                  className={`${
                    checkRoleStatusField && settingsData.gstnumber !== ''
                      ? "bg4 not-allowed"
                      : "bg1"
                  } br4 h40 mt8 fs14 w100 p16`}
                  disabled={checkRoleStatusField && settingsData.gstnumber !== ''}
                  onBlur={handleChange}
                  defaultValue={settingsData.gstnumber}
                />
                {checkRoleStatusField > 0 && settingsData.gstnumber !== '' && (
                  <span className="tooltip-texts">
                    This field is not editable. Please contact support or your coordinator for any necessary changes
                  </span>
                )}
              </div>
              {errorMsgData.gstnumber && (
                <p className='error-message'>{errorMsgData.gstnumber}</p>
              )}
            </div>
          </div>
        )}
      </div>
      {(user.access_by_login == 0) && <div className='reset-password brd-t2'>
        <div className='reset-pass-head mt24'>
          <div className='v-center'>
            <p className=' fc3 fs18 ls1 lh22 mr8'>Reset Your Password</p>
            <Toggle initialValue={initialValue} onChange={passwordHandle} />
          </div>
          <p className='ls1 fc6 fs14 mt4 mb24 lh22'>
            Secure your account with a new password. Click the toggle to change
            your password.
          </p>
        </div>
        {passwordOnOff  && (
          <>
            <div className='form-group-settings'>
              <p className='fc15 fw6 fs14 ls1'>New Password</p>
              <div className='password-inputs pr'>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id='password'
                  placeholder='Reset your password'
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  autoComplete='off'
                  className='bg1 br4 h40 mt8 fs14 w100 p16'
                  ref={passwordRef}
                />
                <span onClick={togglePasswordVisibility}>
                  {!showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
            <div className='button-container df jce mt24 pb24'>
              <button
                type='button'
                className='btn-blue bg1 br24 fs14 cp pl16 pr16 pt10 pb10'
                onClick={handlePassword}
              >
                Update Password
              </button>
            </div>
          </>
        )}
      </div>}

      {isPhoneVerificationOpen && (
        <Popup
          onClose={closePhoneVerification}
          title={'Mobile Phone Verification'}
        >
          <OtpVerify
            otpHandler={otpHandler}
            onClose={closePhoneVerification}
            settingsData={settingsData}
            varifyOTPFun={varifyOTPFunHandle}
          />
        </Popup>
      )}
      <ToastContainer position='bottom-right' />
      <div ref={bottomRef}></div>
    </div>
    
    
  
  )
}

export default Settings
